<div class="header-subheader-container">
  <span class="statusInitial">
    <p class="order-status-info" [style]="{'--status-color':color()}">
      {{ header()}}
    </p>
  </span>
  <span class="subheader-tag">{{subheader()}}</span>
</div>